import { withTranslation, TFunction } from "react-i18next";
import { Link } from "react-router-dom";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import {
  FooterSection,
  FooterWrapper,
  FooterColumn,
  SocialLinks,
  Brand,
  Copyright,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <FooterSection>
      <Container>
        <FooterWrapper>
          <Brand>
            <SvgIcon src="logo.svg" width="68px" height="72px" />
            <p>{t("Software com inteligência artificial, feito em Sinop, Mato Grosso.")}</p>
          </Brand>
          <FooterColumn>
            <h4>{t("Company")}</h4>
            <a href="/#about">{t("About")}</a>
            <a href="/#product">{t("Product")}</a>
            <a href="/#contact">{t("Contact")}</a>
          </FooterColumn>
          <FooterColumn>
            <h4>{t("Legal")}</h4>
            <Link to="/privacidade">{t("Privacy Policy")}</Link>
            <Link to="/termos">{t("Terms of Use")}</Link>
            <Link to="/exclusao">{t("Data Deletion")}</Link>
            <Link to="/seguranca">{t("Information Security")}</Link>
          </FooterColumn>
          <FooterColumn>
            <h4>{t("Social")}</h4>
            <SocialLinks>
              <a href="https://instagram.com/bentek.br" target="_blank" rel="noopener noreferrer">
                <SvgIcon src="instagram.svg" width="24px" height="24px" />
              </a>
              <a href="https://wa.me/5566999515678" target="_blank" rel="noopener noreferrer">
                <SvgIcon src="whatsapp.svg" width="24px" height="24px" />
              </a>
            </SocialLinks>
          </FooterColumn>
        </FooterWrapper>
        <Copyright>
          © {new Date().getFullYear()} BRAVORO INOVA SIMPLES (I.S.), CNPJ 67.018.680/0001-41. {t("All rights reserved")}
        </Copyright>
      </Container>
    </FooterSection>
  );
};

export default withTranslation()(Footer);
